import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SubscriptionDiscountsEffects } from './+state/subscription-discounts.effects';
import { reducer, subscriptionDiscountsFeatureKey } from './+state/subscription-discounts.reducer';
import { SubscriptionDiscountsApiService } from './services/subscription-discounts-api.service';

@NgModule({
  providers: [SubscriptionDiscountsApiService],
  imports: [
    CommonModule,
    StoreModule.forFeature(subscriptionDiscountsFeatureKey, reducer),
    EffectsModule.forFeature([SubscriptionDiscountsEffects]),
  ],
})
export class SubscriptionDiscountsModule {}
